/*
 * modules/common文件夹为公共vuex状态管理器不可随意更改
 * 各业务工程需要vuex请自行建立独立文件
 * */
import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/common/app";
import user from "./modules/common/user";
import getters from "./getters";
import nav from "./modules/common/nav";
import addRouters from "./modules/common/generateRoutes";
import shop from "./modules/common/shop";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    addRouters,
    shop,
    nav
  },
  getters
});

export default store;
